module.exports = __webpack_public_path__ + "static/img/login-bg.3fe4732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-bg.png
// module id = Aic+
// module chunks = 1